import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AreaService } from '../../area.service';
import { AreaModel, LightWeightAreaModel } from '../../area.model';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

@Component({
    selector: 'fi-area-delete-transfer-card',
    templateUrl: './area-delete-transfer-card.component.html',
    styleUrls: ['./area-delete-transfer-card.component.scss'],
    standalone: false,
})
export class AreaDeleteTransferCardComponent implements OnInit {
    @Input() area;
    @Input() onlySubAreas: boolean;
    @Input() transferAreaId;
    @Output('transferAreaIdChange') transferAreaIdChangeEmitter = new EventEmitter();
    @Input() titleText: string;
    @ViewChild('matSelect', { static: false }) matSelect: MatSelect;

    areas: Array<LightWeightAreaModel>;

    constructor(private areaService: AreaService) {}

    ngOnInit() {
        this.areaService.GetLightWeightHieracialAreas().then((data) => {
            this.areas = this.expandAreas(data).filter((item) => item.Id !== this.area.Id);
        });
    }

    expandAreas(areas: Array<AreaModel>, level = 0): Array<AreaModel> {
        let result = [];
        areas.forEach((item) => {
            item.$$level = level;
            result.push(item);
            if (item.ChildItems && item.ChildItems.length > 0) {
                result = result.concat(this.expandAreas(item.ChildItems, level + 1));
            }
        });
        return result;
    }

    transferAreaIdChange() {
        this.transferAreaIdChangeEmitter.emit(this.transferAreaId);
    }

    getSelectedAreaName() {
        if (this.matSelect.selected instanceof MatOption) {
            return this.matSelect.selected.viewValue;
        }
    }
}
